/** 项目默认展示名称（后端 web_name 未返回时使用） */
export const APP_NAME = '一带一路兑现版'
